<template>
    <BaseForm>
        <template #fields>
            <PresetTextField
                :value="values.companyGroup"
                :presets="COMPANY_GROUP_PRESETS"
                :label="$t('company-group')"
                :error-messages="errors.companyGroup"
                @input="setFieldValue('companyGroup', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('companyGroup', true)"
            />
            <TextField
                :value="values.businessDomain"
                :label="$t('business-domain')"
                :error-messages="errors.businessDomain"
                @input="setFieldValue('businessDomain', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('businessDomain', true)"
            />
            <TextField
                :value="values.department"
                :label="$t('department')"
                :error-messages="errors.department"
                @input="setFieldValue('department', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('department', true)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { COMPANY_GROUP_PRESETS } from '@/components/Form/defaults';
import PresetTextField from '@/components/Form/PresetTextField.vue';
import TextField from '@/components/Form/TextField.vue';
import { useEventInjection } from '@/event/composables/useEventInjection';
import { useForm } from '@/forms/composables/useForm';
import { computed } from 'vue';
import { EventOrganisationSchema } from '../schemas';
const props = defineProps<{ eventId: string }>();
const eventId = computed(() => props.eventId);
const { event, updateEvent } = useEventInjection();

const { errors, values, setFieldValue, setFieldTouched, validate, onDiscard, resetForm } = useForm(
    EventOrganisationSchema,
    computed(() => ({
        companyGroup: event.value?.companyGroup ?? '',
        businessDomain: event.value?.businessDomain ?? '',
        department: event.value?.department ?? '',
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await updateEvent({ id: eventId.value, ...values.value });
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
